import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ForgotPasswordRequest } from '../../models/forgot-password.request';
import { TYPE_NOTIFY } from 'src/app/shared/constants';
import { AuthService } from '../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  fpFormGroup: FormGroup;
  isUpdating = false;
  isSendEmail = false;
  notifications: any;
  emailEntered = { email: '' };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private notificationService: NotificationService
  ) {
    this.translate.get('forgotPassword.notifications')
      .subscribe((res) => this.notifications = res);
  }

  ngOnInit() {
    this.fpFormGroup = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  fpFormGroupSubmit(fpFormGroup: FormGroup) {
    if (!this.isSendEmail) {
      this.emailEntered.email = this.fpFormGroup.value.email;
      this.sendEmail(fpFormGroup.value.email);
    } else {
      this.returnLogIn();
    }
  }

  sendEmail(email) {
    // TODO: Pendiente de implementar servicios
    const request = new ForgotPasswordRequest(email, TYPE_NOTIFY[2]);
    this.authService.recoveryAccount(email).subscribe(
      response => {
        this.isSendEmail = true;
      },
      (error) => {
        console.error(error);
        this.notificationService.error(this.notifications.sendEmailError);
      }
    );
  }

  returnLogIn() {
    this.router.navigate(['/login']);
  }
}
